import { render } from "./modal-confirm.vue?vue&type=template&id=25c625f5&lang=pug"
import script from "./modal-confirm.vue?vue&type=script&setup=true&lang=js"
export * from "./modal-confirm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__